// Houses strings for Rsuite alerts

// App Alerts
export const AlertMsgClipboard = 'Copied to clipboard!';
export const AlertMsgUnlabeledError = 'Something is wrong!';

export const AlertMsgNoSpreadsheet =
  'Unable to download spreadsheet at this time.';
export const AlertMsgNoShapeFile = 'No city boundary to display.';
export const AlertMsgZoningInProcess = 'Zoning is in process.';

export const AlertMsgSnapshotTaken = 'Snapshot taken!';
export const AlertMsgSalesOutreach =
  'Thank you for your interest. A member of our sales team will reach out to you within the next 48 hours.';
export const AlertMsgSalesOutreachFail =
  'Sorry, we were unable to send a contact request at this time.';

// Payment Alerts
export const AlertMsgPaymentFail = 'Payment Failure.';
export const AlertMsgPaymentSuccess = 'Hooray~~ You have paid successfully~~';
export const AlertMsgPaymentSuccessConfirmation =
  'You have paid successfully, but please do contact us to confirm!';

// Password Alerts
export const AlertMsgPasswordResetSuccess = 'Password reset!';
export const AlertMsgPasswordResetEmailSent = 'Password reset email sent!';
export const AlertMsgPasswordResetAuthenticationCodeSent =
  'Authentication code email sent!';
export const AlertMsgPasswordResetInvalidEmail =
  'Woops! Perhaps you entered the wrong email?';
export const AlertMsgPasswordForget =
  'Looks like you have a confirmed account. Complete the forgot password to restore access.';
export const AlertMsgPasswordInvalidLength =
  'Does not conform to password policy: Length must be at least 8 characters';
export const AlertMsgPasswordMissingSpecial =
  'Does not conform to password policy: Must include special character(s)';
export const AlertMsgPasswordMissingUppercase =
  'Does not conform to password policy: Must include uppercase character(s)';

// Email Alerts
export const AlertMsgInvalidEmail = 'Email not valid!';
export const AlertMsgRegistrationEmail = 'Email successfully sent.';
export const AlertMsgEmailSuccess =
  'We have received your message and will reach out to you within the next few days.';
export const AlertMsgEmailFail =
  'Sorry, we were unable to send a contact request at this time. Try again soon.';
export const AlertMsgEmailNotFound = 'Email not found for registration.';
export const AlertMsgEmailAlreadyRegistered =
  'Account already activated, resend email to receive confirmation email.';

// User Actions
export const AlertMsgDeleteUserSuccess = 'Deleted user.';
export const AlertMsgDeleteUserFail = 'Unable to delete user.';

// Form Errors
export const AlertMsgFormFieldMissingEmailPassword =
  'Both Email and Password are required.';
export const AlertMsgFormFieldMissingEmail = 'Email field is required.';
export const AlertMsgFormFieldMissingPassword = 'Password field is required.';
export const AlertMsgFormFieldMissingPasswordConfirm =
  'Confirm password is required.';
export const AlertMsgFormFieldMissingPasswordsBoth =
  'Both password fields are required.';
export const AlertMsgFormFieldMismatchPassword = 'Passwords do not match.';

// License Management
export const AlertMsgEmailSendFailure = 'Unable to Send License';

// Admin Panel
export const AlertUnableToDownloadReport = 'Unable to Download Report';

// TOT tab
export const AlertMsgTOTTabUnableToSubmitPayment = 'Unable to submit payment';
export const AlertMsgTOTTabUnableToCalculate =
  'Unable to calculate payment amount';
